<div class="lock-tree-container" tabindex="1">
  <div class="row medium-height search-bar">
    @if (dataSource) {
      <div class="table-filter">
        <input (keyup)="cps.applyFilter.next($event.target.value)" [value]="search_string" placeholder="Search tree"/>
      </div>
    }

    <button mat-button class="bordered-button" (click)="toggleFullTree()">
      @if (isExpanded) {
        <span>Close all</span>
      }
      @if (!isExpanded) {
        <span>Expand all</span>
      }
    </button>
  </div>

  <mat-tree #lockTree [dataSource]="dataSource" [treeControl]="treeControl" class="lock-tree">
    <mat-tree-node *matTreeNodeDef="let node" [id]="node.id">
      <div class="tree-node-border"></div>
      <li>
        <div class="mat-tree-node">
          <ng-container [ngTemplateOutlet]="lockTemplateNode"
          [ngTemplateOutletContext]="{ $implicit: node}"></ng-container>
        </div>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [id]="node.id">
      <li>
        <div class="mat-tree-node">
          <div class="horizontal-border"></div>
          <button mat-icon-button matTreeNodeToggle
                  [attr.aria-expanded]="treeControl.isExpanded(node)"
                  [attr.aria-label]="(treeControl.isExpanded(node) ? 'Collapse ' : 'Expand ') + (node.name || 'node')">
            <mat-icon aria-hidden="true">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <ng-container [ngTemplateOutlet]="lockTemplateNode"
          [ngTemplateOutletContext]="{ $implicit: node}"></ng-container>
        </div>
        <ul class="tree-nested-node-list">
          @if (treeControl.isExpanded(node)) {
            <div class="cover">
              <div class="vertical-border"></div>
              <ng-container matTreeNodeOutlet></ng-container>
            </div>
          }
        </ul>
      </li>

    </mat-nested-tree-node>
  </mat-tree>
</div>

<ng-template #lockTemplateNode let-node>
  @if (node.is_parent) {
    {{node.name}}
  }
  @if (node.type==='constant_property') {
    <ng-container
      [ngTemplateOutlet]="constantProperty"
    [ngTemplateOutletContext]="{ $implicit: node}"></ng-container>
  }
  @if (node.type==='component_type') {
    <ng-container
      [ngTemplateOutlet]="componentType"
    [ngTemplateOutletContext]="{ $implicit: node}"></ng-container>
  }
  @if (node.type==='event_type') {
    <ng-container
      [ngTemplateOutlet]="eventType"
    [ngTemplateOutletContext]="{ $implicit: node}"></ng-container>
  }
</ng-template>

<ng-template #constantProperty let-node>
  <div class="constant-property-node"
       [ngClass]="{'highlight-node': selected.includes(node.id), 'cp-editing': editing_node_id() === node.id}">
    <div class="row min-height node-header">
      <div class="header-content">
        <button type="button" mat-icon-button class="cp-expand-toggle"
                [attr.aria-expanded]="!!prop_expanded[node.id]"
                [attr.aria-label]="(prop_expanded[node.id] ? 'Collapse ' : 'Expand ') + node.name"
                (click)="prop_expanded[node.id]=!prop_expanded[node.id]">
          <i class="fa" aria-hidden="true" [ngClass]="prop_expanded[node.id]? 'fa-minus':'fa-plus'"></i>
        </button>
      </div>
      <div class="cp-property-text">
        <div class="cp-property-eyebrow">
          @if (editing_node_id() === node.id) {
            Editing constant property
          } @else {
            Constant property
          }
        </div>
        <div class="label">{{node.name}}</div>
      </div>
      @if (can_edit && editing_node_id() !== node.id) {
        <button mat-button class="cp-edit-button"
                [disabled]="saving()"
                [attr.data-cp-node-id]="node.id"
                [attr.aria-label]="'Edit property ' + node.name"
                (click)="editProperty(node)">Edit
        </button>
      }
    </div>
    @if (prop_expanded[node.id] && editing_node_id() !== node.id) {
      <div class="node-content">
        @if (node.description) {
          <div><label>Description:</label> {{node.description}}</div>
        }
        <div><label>Data type:</label> {{node.data_type}}</div>
        <div><label>Aggregation:</label> {{node.aggregation ?? 'None'}}</div>
        @if (node.is_calculation) {
          <div><label>Formula:</label> <span>{{node.name_formula}}</span></div>
        }
      </div>
    }
    @if (can_edit && editing_node_id() === node.id) {
      <div class="node-content cp-edit-form" [formGroup]="form" (keydown.escape)="onFormEscape($event)">
        @if (loading_property()) {
          <div class="cp-loading-label" role="status" aria-live="polite" aria-busy="true">Loading property...</div>
        }
        @if (editing_property) {
          <mat-form-field>
            <mat-label>Description</mat-label>
            <input matInput #firstFormField formControlName="description"/>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Aggregation</mat-label>
            <mat-select formControlName="aggregation">
              <mat-option [value]="null">Not set</mat-option>
              @for (aggregation of aggregations; track aggregation) {
                <mat-option [value]="aggregation">{{aggregation}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (editing_property.attributes.is_calculation) {
            <mat-form-field>
              <mat-label>Formula</mat-label>
              <textarea matInput rows="3" class="cp-formula-input"
                        formControlName="name_formula"></textarea>
              <mat-error>Constant properties of type calculation must have a formula.</mat-error>
            </mat-form-field>
          }
        }

        @if (recalculation_pending()) {
          <div class="cp-recalc-notice" role="status">
            <mat-icon aria-hidden="true">warning</mat-icon>
            <span>{{recalculation_notice}}</span>
          </div>
        }

        @if (form.hasError('conflict')) {
          <div class="cp-conflict-notice" role="alert">
            <mat-icon aria-hidden="true">error_outline</mat-icon>
            <span>This constant property was changed by someone else since you opened it.
              Reload to see the latest version before saving.</span>
            <button type="button" mat-button class="cp-conflict-reload-button"
                    (click)="reloadAfterConflict()">Reload
            </button>
          </div>
        }

        <div class="row cp-edit-actions">
          @if (saving()) {
            <span class="cp-saving-label" role="status" aria-live="polite" aria-busy="true">Saving...</span>
          }
          <button mat-button class="cp-cancel-button"
                  [disabled]="saving()" (click)="cancelEdit()">Cancel
          </button>
          <button mat-button class="cp-save-button"
                  [disabled]="saving() || !editing_property" (click)="saveProperty()">Save
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>


<ng-template #componentType let-node>
  <div class="component-type-node" [ngClass]="{'highlight-node' : selected.includes(node.id)}">

    <div class="row min-height node-header">
      <div class="label">{{node.name | upperfirst}} dependencies</div>
    </div>
  </div>
</ng-template>

<ng-template #eventType let-node>
  <div class="cp-event-type-node">{{node.name | upperfirst}} dependencies</div>
</ng-template>
